import React from 'react';
import { Avatar, Tooltip } from 'antd';
import useAuthUploadSrc from '../../../hooks/useAuthUploadSrc';

const badgeStyle = {
  position: 'absolute',
  bottom: -12,
  right: -6,
  zIndex: 10,
  border: '2px solid #fff',
  borderRadius: '50%',
  boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
  cursor: 'default',
};

const AiStaffNodeBadge = ({ avatarUrl, name, jobTitle }) => {
  const src = useAuthUploadSrc(avatarUrl);
  const tip = [name, jobTitle].filter(Boolean).join(' - ');

  return (
    <Tooltip title={tip} placement="bottom">
      <Avatar size={24} src={src} style={badgeStyle}>
        {name?.[0] || 'AI'}
      </Avatar>
    </Tooltip>
  );
};

export default AiStaffNodeBadge;
